var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"p-loading",style:({ background: _vm.bgColor })},[_c('div',{staticClass:"p-loading__item"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }